import {createUseStyles} from "react-jss";

const useStyles = createUseStyles({
    backgroundContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
    },
});

export const BackgroundContainer = ({children}) => {
    const classes = useStyles();

    return (
        <div
            className={classes.backgroundContainer}
        >
            {children}
        </div>
    )
}